<template>
	<button
		class="speaker-btn"
		:class="{ muted: !isPlaying }"
		:aria-label="isPlaying ? 'Pausar música' : 'Ativar música'"
		:aria-pressed="isPlaying"
		@click="$emit('toggle')"
	>
		<img
			src="../assets/images/SPEAKER-ICON.png"
			alt="Som"
		/>
	</button>
</template>

<script>
export default {
	name: 'SpeakerButton',
	props: {
		isPlaying: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['toggle'],
};
</script>

<style scoped>
.speaker-btn {
	display: flex;
	align-items: center;
	background: none;
	border: none;
	cursor: pointer;
	color: var(--ink-dim);
	padding: 4px;
}
.speaker-btn img {
	height: 56px;
	width: auto;
	opacity: 0.55;
	transition:
		opacity 0.3s ease,
		transform 0.3s ease,
		filter 0.3s ease;
}
.speaker-btn:hover img {
	transform: scale(1.05);
}
.speaker-btn:not(.muted) img {
	opacity: 1;
	animation: speaker-pulse 2.4s ease-in-out infinite;
}
.speaker-btn.muted img {
	animation: none;
}
@keyframes speaker-pulse {
	0%,
	100% {
		filter: brightness(1);
	}
	50% {
		filter: brightness(1.4);
	}
}

@media (max-width: 900px) {
	.speaker-btn img {
		height: 42px;
	}
}
</style>
